


























import IsocronForm from "@/components/Isocron/Form.vue";

import { Vue, Component, Prop } from "vue-property-decorator";
import { currentScoutingStore } from "@/store/typed";
import VAccordion from "@/components/VAccordion.vue";
import ScoutingPlaceItem from "@/components/ScoutingPlace/Item.vue";
import { Isocron, Scouting } from "../../models";

export type Isocronable = Isocron | Scouting;

@Component({
  components: {
    VAccordion,
    IsocronForm,
    ScoutingPlaceItem,
  },
})
export default class IsocronCollapsible extends Vue {
  @Prop({ default: true }) readonly isOpened!: boolean;

  private loading = false;
  private item: Isocronable | null = null;
  private opened = !!this.isOpened;

  async mounted() {
    await this.load();
  }

  async load() {
    await currentScoutingStore.loadScoutingPlaces();
    if (currentScoutingStore.scouting) {
      this.item = currentScoutingStore.scouting;
    }
  }

  get title() {
    if (this.item) {
      const um = this.item.isocronType === "duration" ? "min" : "km";
      return `Isocrona (${this.item.isocronRange} ${um})`;
    }
    return "Isocrona";
  }

  get icon() {
    if (this.item) {
      const meansType = this.item.isocronMeansType;
      const item = Isocron.meansTypes.find((t) => t.id === meansType);
      return item?.icon || "accordion-isocron";
    }
    return "accordion-isocron";
  }

  get scoutingPlaces() {
    return currentScoutingStore.scoutingPlaces;
  }

  get scouting() {
    return currentScoutingStore.scouting;
  }

  async onApply(item: Isocronable) {
    this.loading = true;
    await currentScoutingStore.saveScouting(item as Scouting);
    await this.load();
    this.loading = false;
    this.opened = false;
  }

  get poiCount() {
    return this.scoutingPlaces.length;
  }

  onStatusChanged(closed: boolean) {
    this.opened = !closed;
  }
}
